import { BaseReportPage } from './bases/BaseReportPage';
import { REPORT } from '@consts/reports';
import { MaterialTypeCutsByReseller } from '@components/reports/resellers/MaterialTypeCutsByReseller';
import { Button, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '@consts/routes';
import { MaterialTypeByReseller } from '@components/reports/resellers/MaterialTypePctByReseller';
import { Materials } from '@consts/materials';
import { ReportTips } from '@components/ReportTips';
import { useReportLoad } from '@hooks/useReportLoad';

interface ResellerProps {
    showTips: boolean;
    dateRange: { startDate: string; endDate: string };
    setDateRange: (dateRange: { startDate: string; endDate: string }) => void;
}

export const ResellersSecondary = ({ showTips, dateRange, setDateRange }: ResellerProps) => {
    const navigate = useNavigate();
    const { data: productNames = [] } = useReportLoad({
        reportType: REPORT.PRODUCTS_PRODUCT_NAMES,
        params: {},
    });

    return (
        <BaseReportPage dateRange={dateRange} setDateRange={setDateRange} title={'MO Insights Resellers'}>
            {showTips && <ReportTips reportType={REPORT.PRODUCTS_TIPS} />}

            <MaterialTypeCutsByReseller dateRange={dateRange} />

            {productNames.map(({ productName }: any) => (
                <MaterialTypeByReseller key={productName} dateRange={dateRange} productName={productName} />
            ))}

            <Grid item xs={12} textAlign={'center'} marginTop={'20px'}>
                <Button color={'primary'} variant={'contained'} onClick={() => navigate(AppRoutes.Resellers)}>
                    More Reports Available on the Previous Page &nbsp; <b>2</b>
                </Button>
            </Grid>
        </BaseReportPage>
    );
};
